// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductsService = {};

ProductsService.postProducts = function (data) {
  return lossClient({
    url: "/producttype/add",
    method: "post",
    data: data,
  });
};

ProductsService.getProductsList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/producttype/Items?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

ProductsService.getProductApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: productsService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: productsService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/producttype/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc,
    // +
    // "&status=" +
    // userInput.status,
    method: "get",
  });
};

ProductsService.putProductApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { userId: data.userId }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { userId: data.userId }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, note: data.note }
      : { userId: data.userId };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "Reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/producttype/${urlRequest}`,
    method: "put",
    headers: {
      "X-RequestId": data.id,
    },
    data: requestDataValidation,
  });
};

ProductsService.putProductRequest = function (data) {
  // console.log("🚀 ~ data:", data);
  return lossClient({
    url: `/producttype/${data.approvalFlag}`,
    method: "put",
    headers: {
      "X-RequestId": data.id,
    },
    data: data,
  });
};

ProductsService.getProductsDetail = function (data) {
  return lossClient({
    url: `/producttype/${data.id}`,
    method: "get",
  });
};

ProductsService.updateProducts = function (data) {
  // console.log("🚀 ~ data:", data);
  const requestBody = {
    TypeofUse: data.TypeOfUse,
    Description: data.description,
    userid: data.userid,
  };
  return lossClient({
    url: "/producttype/edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

ProductsService.deleteProducts = function (data) {
  return lossClient({
    url: "/producttype/delete",
    method: "delete",
    headers: {
      "X-RequestId": data.id,
    },
    data: data,
  });
};

export default ProductsService;
